/**
 * Predarea contextului de la mini-scan catre inregistrare.
 *
 * Mini-scanul e cel mai valoros punct de intrare pe care il avem: userul tocmai
 * a vazut un scor real pentru brandul LUI. Pana la 2026-08-19, CTA-ul de acolo
 * trimitea doar `/register?utm_source=…` — fara brand, fara industrie, fara
 * scan_id. Userul retasta exact ce completase cu 30 de secunde inainte, apoi
 * astepta un scan de ~4 minute pentru date pe care le vazuse deja gratis.
 *
 * `RegisterPage` stia deja sa citeasca `?industry=` (pages/RegisterPage.js),
 * iar clasamentul si pagina publica de brand il trimiteau corect
 * (pages/LeaderboardPage.js, pages/BrandPublicPage.js). Mini-scanul era singurul
 * care nu-l trimitea.
 */

/** Lungime maxima pentru valorile puse in query string — evitam URL-uri absurde
 *  daca `brand_name` vine dintr-un input needitat. */
const MAX_LEN = 120;

const clean = (v) => {
  if (v == null) return '';
  const s = String(v).trim();
  if (!s || s.length > MAX_LEN) return '';
  return s;
};

/**
 * Construieste linkul de inregistrare pornind de la rezultatul unui mini-scan.
 *
 * @param {object} result   rezultatul mini-scanului (brand_name, industry, scan_id, shareable)
 * @param {string} utmSource valoarea de utm_source pentru atribuire
 * @returns {string} path relativ, ex. `/register?utm_source=mini_scan&industry=farmacii&brand=Catena`
 */
export function registerLinkFromMiniScan(result, utmSource = 'mini_scan') {
  const params = new URLSearchParams();
  params.set('utm_source', utmSource || 'mini_scan');

  const industry = clean(result?.industry);
  if (industry) params.set('industry', industry);

  const brand = clean(result?.brand_name);
  if (brand) params.set('brand', brand);

  // Trimitem scan_id DOAR daca scanul e partajabil — altfel e un identificator
  // pe care backendul oricum nu il poate servi mai tarziu.
  const scanId = result?.shareable ? clean(result?.scan_id) : '';
  if (scanId) params.set('scan_id', scanId);

  return `/register?${params.toString()}`;
}

export default registerLinkFromMiniScan;
